(function () {

    "use strict";

    function basicEditService($state, $stateParams, $q, basicService) {

        var vm = this;

        vm.instantiate = function (edit) {

            basicService.instantiate(edit);

            edit.service = {};
            edit.entity = {};

            edit.cancel = function () {

            };

            edit.save = function () {

                var defered = $q.defer();
                var promise = defered.promise;

                edit.service.save([edit.entity]).then(function (data) {
                    defered.resolve(data);
                }, function () {
                    defered.reject();
                });

                return promise;
            };

            edit.loadEntity = function () {
                edit.loadMetadatas();
                edit.idEntity = getIdEntity();
                var defered = $q.defer();
                var promise = defered.promise;
                if (edit.idEntity > 0) {
                    edit.service.getItem(edit.idEntity).then(function (entity) {
                        edit.entity = entity;
                        defered.resolve(true);
                    });
                }
                else {
                    edit.service.new().then(function (entity) {
                        edit.entity = entity;
                        defered.resolve(true);
                    });
                }
                return promise;

                function getIdEntity() {
                    if (edit.idEntity) {
                        return edit.idEntity;
                    }

                    return parseInt($stateParams.idEntity);
                }
            };

            edit.loadMetadatas = function () {

                var defered = $q.defer();
                var promise = defered.promise;
                edit.entity = edit.service.getMetadatas().then(function (metadatas) {
                    edit.metadatas = metadatas;
                    defered.resolve(true);
                });
                return promise;
            };

            edit.goHome = function () {
                $state.go("home");
            };

            edit.goList = function () {
                $state.go(edit.stateList);
            };

            return edit;
        };

    }

    basicEditService.$inject = ["$state", "$stateParams", "$q", "sphforms.basicService"];

    angular.module("sphforms.main").service("sphforms.basicEditService", basicEditService);

})();
